import { SeoRenderer } from "../../../common/helpers/seo";
import TeachingSettings from "./loadable";

export default {
    component: TeachingSettings,
    renderSeo: (store: any, allMessage: {[ key: string]: string }, lang: string) => {
        SeoRenderer({
            title: allMessage["teachingSettings.title"],
            allMessage,
            lang,
            type: "article",
        });
    },
};
